import { DeviceTracking } from '@/api/apis/composer';

type DeviceNode = DeviceTracking['deviceNodes'][number];

export type LegStateEnum = 'not_started' | 'in_progress' | 'completed' | 'stale_completed';

export const LegState = {
  NotStarted: 'not_started',
  InProgress: 'in_progress',
  Completed: 'completed',
  StaleCompleted: 'stale_completed',
} as const satisfies Record<string, LegStateEnum>;

export const getLegState = (node: DeviceNode, index: number, nodes: DeviceNode[]): LegStateEnum => {
  const depComplete = node.departureCheckpoint.isComplete;
  const arrComplete = node.arrivalCheckpoint.isComplete;

  if (depComplete && arrComplete) return LegState.Completed;
  if (depComplete && !arrComplete) return LegState.InProgress;
  if (!depComplete && arrComplete) return LegState.Completed;

  // If a later leg has already started, the team must have finished this one
  // even though the checkpoints did not get marked off in order.
  for (let i = index + 1; i < nodes.length; i += 1) {
    if (nodes[i].departureCheckpoint.isComplete) return LegState.StaleCompleted;
  }
  return LegState.NotStarted;
};

export const isLegComplete = (state: LegStateEnum): boolean =>
  state === LegState.Completed || state === LegState.StaleCompleted;
